import React, { useState } from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrModalV2, { MODAL_THEME_FIXED_FOOTER_BUTTON } from 'client/components/SrModalV2/SrModalV2';

import { SR_BUTTON_THEME_ADOBE_GREY } from '../SrButton/SrButton';

const SrViewPhotosCard = ({
  photos,
}) => {
  const [photosModalIsOpen, setPhotosModalIsOpen] = useState(false);

  return (
    <SrBox position='relative'>
      <SrBox
        position='absolute'
        bottom='0'
        left='25px'
        width='calc(100% - 50px)'
        height='197px'
        borderRadius='7px'
        background={`linear-gradient(180deg, rgba(19, 38, 48, 0) 60.94%, rgba(19, 38, 48, 0.22) 100%),
            url(${photos[0]})`}
        backgroundPosition='center'
        backgroundSize='cover'
        backgroundRepeat='no-repeat'
        filter='blur(27px)'
      />
      <SrBox
        onClick={() => setPhotosModalIsOpen(true)}
        borderRadius='7px'
        background={`linear-gradient(180deg, rgba(19, 38, 48, 0) 60.94%, rgba(19, 38, 48, 0.22) 100%),
            url(${photos[0]})`}
        backgroundPosition='center'
        backgroundSize='cover'
        backgroundRepeat='no-repeat'
        height='252px'
        width='100%'
        paddingTop='192px'
        boxSizing='border-box'
        cursor='pointer'
        position='relative'
        z-index='1'
      >
        <SrText
          display='block'
          align='center'
          font='greycliff'
          weight='800'
          fontSize='18px'
          lineHeight='26px'
          letterSpacing='0.5px'
          color='white'
          textShadow='0px 5px 13px rgba(19, 38, 48, 0.2)'
        >
          {photos.length < 2 ?
            'View Full Photo' : `View All ${photos.length} Photos`
          }
        </SrText>
      </SrBox>
      {photosModalIsOpen &&
        <SrModalV2
          theme={MODAL_THEME_FIXED_FOOTER_BUTTON}
          onClose={() => setPhotosModalIsOpen(false)}
          buttonTheme={SR_BUTTON_THEME_ADOBE_GREY}
          showCloseButton
          overflow='auto'
        >
          <SrBox paddingBottom='80px'>
            {photos.map((photo) => (
              <img alt='unit' src={photo} width='100%' height='auto' />
            ))}
          </SrBox>
        </SrModalV2>
      }
    </SrBox>
  );
};

SrViewPhotosCard.propTypes = {
  photos: PropTypes.array,
};

SrViewPhotosCard.displayName = 'SrViewPhotosCard';

export default SrViewPhotosCard;
